import * as CONSTANTS from './CONSTANTS';
import i18n from './i18n';

export const  check_auth = async (token)=>{
          try {

            let response = await  fetch(CONSTANTS.DEFAULT_URL+'users/me', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json' ,
                'Authorization': 'Bearer '+token

              },
            })
            let json = await response.json();
            if(response.status !== 200 && token !== null){
              localStorage.clear();
                  window.location = "/"+i18n.language+"/login"
            }
        
                return { success: true, data: json };
        
            
        
        } catch (error) {
            return { success: false };
          }
}

export const  getUserLocation = async (token)=>{
  
    try {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
              const userLocation = {            // ADDED
                lat: position.coords.latitude,  // ADDED
                lng: position.coords.longitude, // ADDED
              };         
              return userLocation;     
              // ADDED
            });
          } else {
            // code for legacy browsers
            return false;
          }
     
  
  
      
  
  } catch (error) {
      return false;
    }
}